// import axiosInstance from "utils/AxiosInstance";
import axiosInstance from "../utils/AxiosInstance";
// Defining the base URL for the API
const BASE_URL = process.env.REACT_APP_BASE_URL;

// ORG APIS BEGINS HERE

/**
 * Creates a new organization.
 * @param {Object} orgPayload - The payload containing the organization data.
 * @returns {Promise} - A promise that resolves when the organization is created successfully.
 * @throws {Error} - If the organization creation fails.
 */


export const getTaskStatus = async (taskId) => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}/organization/task-status/${taskId}`
    );

    if (response.status === 200) {
      return response.data;
    } else {
      const errorData = response.data;

      throw new Error(errorData.message || "Unable to create organization");
    }
  } catch (error) {
    console.error("Organization creation Failed:", error);
    throw error;
  }
};

export const createOrganization = async (orgPayload) => {
  try {
    const response = await axiosInstance.post(
      `${BASE_URL}/organization/new`,
      orgPayload
    );


    console.log(response,"asj")

    if (response.status === 201) {
      return response.data;
    } else {
      const errorData = response.data;

      throw new Error(errorData.message || "Unable to create organization");
    }
  } catch (error) {
    console.error("Organization creation Failed:", error);
    throw error;
  }
};

/**
 * Retrieves a list of organizations or a specific organization by ID.
 *
 * @param {string} organizationId - The ID of the organization to retrieve. Optional.
 * @returns {Promise<Object>} - A promise that resolves to the organization(s) data.
 * @throws {Error} - If an error occurs while retrieving the organization(s).
 */
export const listOrganizations = async (organizationId = null) => {
  try {
    let endpoint = `${BASE_URL}/organization`;
    if (organizationId) {
      endpoint = `${BASE_URL}/organization/${organizationId}`;
    }
    const response = await axiosInstance.get(endpoint);
    const data = await response.data;
    return data.organization;
  } catch (error) {
    throw error;
  }
};

/**
 * Updates an organization with the given ID using the provided payload.
 *
 * @param {string} orgId - The ID of the organization to update.
 * @param {object} orgPayload - The payload containing the updated organization data.
 * @returns {Promise<object>} - A promise that resolves to the updated organization data.
 * @throws {Error} - If the response status is not 200 or 204.
 */
export const updateOrganization = async (orgId, orgPayload) => {
  try {
    const endpoint = `${BASE_URL}/organization/${orgId}`;
    const response = await axiosInstance.patch(endpoint, orgPayload);
    if (response.status === 200 || response.status === 204) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }
  } catch (error) {
    console.error("Organization Updation Failed:", error);
    throw error;
  }
};

/**
 * Deletes an organization with the specified ID.
 *
 * @param {string} organizationId - The ID of the organization to delete.
 * @returns {Promise} - A promise that resolves to the deleted organization data.
 * @throws {Error} - If an error occurs while deleting the organization.
 */
export const deleteOrganization = async (organizationId) => {
  try {
    const endpoint = `${BASE_URL}/organization/${organizationId}`;
    const response = await axiosInstance.delete(endpoint);
    const data = await response.data;
    return data;
  } catch (error) {
    throw error;
  }
};

/**
 * Changes the status of an organization.
 * @param {string} orgId - The ID of the organization.
 * @param {string} action - The action to perform on the organization's status.
 * @returns {Promise} - A promise that resolves to the response data.
 * @throws {Error} - If an error occurs during the status change.
 */
export const organizationStatusChange = async (orgId, action) => {
  try {
    const endpoint = `${BASE_URL}/organization/${orgId}/status-change/${action}`;
    const response = await axiosInstance.patch(endpoint);
    const data = await response.data;
    return data;
  } catch (error) {
    console.error("Toggle failed :", error);
    throw error;
  }
};

// ORG APIS ENDS HERE

// ORG DOC APIS BEGINS HERE
/**
 * Deletes a document from an organization.
 *
 * @param {string} orgId - The ID of the organization.
 * @param {string} docId - The ID of the document.
 * @returns {Promise} - A promise that resolves to the deleted document data.
 * @throws {Error} - If the document deletion fails.
 */

export const dropOrgDoc = async (orgId, docId) => {
  try {
    const endpoint = `${BASE_URL}/organization/${orgId}/doc/${docId}`;
    const response = await axiosInstance.delete(endpoint);
    const data = await response.data;
    return data;
  } catch (error) {
    console.error("Document delete Failed :", error);
    throw error;
  }
};

/**
 * Manages a document for an organization.
 *
 * @param {string} orgId - The ID of the organization.
 * @param {string} docId - The ID of the document.
 * @param {object} doc - The document to be managed.
 * @returns {Promise<object>} - A promise that resolves to the data of the managed document.
 * @throws {Error} - If the document management fails.
 */
export const manageOrgDoc = async (orgId, docId, doc) => {
  try {
    const endpoint = `${BASE_URL}/organization/${orgId}/doc/${docId}`;
    const response = await axiosInstance.post(endpoint, doc);
    const data = await response.data;
    return data;
  } catch (error) {
    console.error("Document delete Failed :", error);
    throw error;
  }
};

// ORG DOC APIS ENDS HERE

// ORG APPS API BEGINS HERE

/**
 * Links or unlinks an app to/from an organization.
 *
 * @param {string} orgId - The ID of the organization.
 * @param {string} appId - The ID of the app.
 * @param {string} action - The action to perform (link or unlink).
 * @returns {Promise} - A promise that resolves to the response data.
 * @throws {Error} - If the toggle fails.
 */
export const linkOrUnlinkApps = async (orgId, appId, action) => {
  try {
    const endpoint = `${BASE_URL}/organization/${orgId}/app/${appId}/link-unlink/${action}`;
    const response = await axiosInstance.post(endpoint);
    const data = await response.data;
    return data;
  } catch (error) {
    console.error("Toggle failed :", error);
    throw error;
  }
};

// ORG APPS API ENDS HERE

// USER API BEGINS HERE

/**
 * Fetches user data for an organization.
 *
 * @param {string} organizationId - The ID of the organization.
 * @param {string} userId - The ID of the user.
 * @returns {Promise} - A promise that resolves to the user data.
 * @throws {Error} - If an error occurs during the API call.
 */
export const fetchUserForOrganization = async (
  organizationId = null,
  userId = null
) => {
  try {
    let endpoint = `${BASE_URL}/users`;
    if (organizationId && !userId) {
      endpoint = `${BASE_URL}/organization/${organizationId}/user`;
    }
    if (organizationId && userId) {
      endpoint = `${BASE_URL}/organization/${organizationId}/user/${userId}`;
    }
    const response = await axiosInstance.get(endpoint);
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};

/**
 * Deletes a user by their ID.
 *
 * @param {Object} user - The user object containing the user's organization ID and user ID.
 * @returns {Promise} - A promise that resolves to the deleted user data.
 * @throws {Error} - If an error occurs during the deletion process.
 */
export const deleteUserById = async (user) => {
  console.log(user);
  try {
    const response = await axiosInstance.delete(
      `${BASE_URL}/organization/user/${user.organization_id}/${user.id}`
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};

/**
 * Creates a new user for an organization.
 * @param {Object} userPayload - The payload containing the user details and organization.
 * @returns {Promise} - A promise that resolves when the user is successfully created.
 * @throws {Error} - If the user creation fails.
 */
export const createOrganizationUser = async (userPayload) => {
  const { organization_id, ...userDetails } = userPayload;
  try {
    const response = await axiosInstance.post(
      `${BASE_URL}/organization/user/new/${organization_id}`,
      userDetails
    );
    if (response.status === 201) {
      return response.data.createdUser;
    }
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};

/**
 * Updates a user by their ID.
 * @param {string} id - The ID of the user to update.
 * @param {object} values - The updated values for the user.
 * @returns {Promise<object>} - A promise that resolves to the updated user data.
 */
export const updateUserById = async (id, values) => {
  try {
    const response = await axiosInstance.patch(
      `${BASE_URL}/organization/user/${values.organization_id}/${id}`,
      values
    );
    return response.data.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};

export const updateUserActiveStatus = async (organization_id, user_id) => {
  try {
    const response = await axiosInstance.patch(
      `${BASE_URL}/organization/changeAccountStatus/${organization_id}`,
      { user_id: user_id }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};

// USER API ENDS HERE
